import React from 'react'
import { TopRowCon } from './styles'
import { QuestionGroupStatus } from './QuestionGroupStatus'
import { Question } from '../../../../Api'

type TopRowProps = {
  question: Question
}

export const TopRow: React.FC<TopRowProps> = ({ question }) => {
  return (
    <TopRowCon>
      {question?.groupText && <h1 className="groupTitle">{question.groupText}</h1>}
      <QuestionGroupStatus />
    </TopRowCon>
  )
}
